/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-background-image.get-names.ts 
*/
:host {
  display: block;
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 100%;
}

.ace-background-image__container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.ace-background-image__container--blur {
  filter: blur(1rem);
  overflow: hidden;
  transform: scale(1.2);
}
.ace-background-image__container--overlay::after {
  background-color: var(--ace-color-surface-glass--image);
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.ace-background-image__image {
  height: 100%;
  left: 0;
  object-fit: cover;
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.ace-background-image__image--loaded {
  opacity: 1;
  transition: 200ms linear;
}
.ace-background-image__image--placeholder {
  opacity: 1;
  transition: 200ms linear;
}
.ace-background-image__image--animation-disabled {
  transition: none !important;
}
.ace-background-image__content {
  position: relative;
}